module.exports = __webpack_public_path__ + "img/Media-Insta.b1c51b30.svg";